// Bumped via package.json + `npm run version`
export const APP_VERSION = 'v1.0.1';
